import { createAction, createSlice } from "@reduxjs/toolkit";
import { getErrorMessage } from "../../../helpers/index.js";
import { offerApi } from "../api/offerApi.js";

const initialState = {
  error: null,
};

export const initializeApp = createAction("offer/initialize");

export const offerSlice = createSlice({
  name: "offer",
  initialState,
  reducers: {
    setError: (state, { payload }) => {
      state.error = payload;
    },
  },
  extraReducers: (builder) => {
    const { getOffer, getVRMData } = offerApi.endpoints;

    builder.addMatcher(
      getOffer.matchRejected || getVRMData.matchRejected,
      (state, { payload }) => {
        state.error = getErrorMessage(payload.data);
      },
    );
  },
});

export const { setError } = offerSlice.actions;

export const getError = ({ offer }) => offer.error;

export default offerSlice.reducer;
